// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m5jV","top":"styles_top__1tV2X","left":"styles_left__2wHpg","description":"styles_description__2GEGe"};